import { Form } from 'factorial-form'

class EmployeeGeneral extends Form {
  constructor(
    values: Record<
      string,
      'date' | 'cents' | number | boolean | string | Record<string, string>
    > = {}
  ) {
    super(values, {
      birthday_on: 'date',
      gender: 'string',
      nationality: 'string',
      phone_number: 'string',
      payment_frequency: 'string',
      preferred_name: 'string',
      pronouns: 'string',
      irpf: 'cents',
      country_metadata: {
        country_of_birth: 'string',
        birthplace: 'string',
        birth_name: 'string',
      },
      share_birthday: 'boolean',
    })
  }
}

export default EmployeeGeneral
